import React from "react";
import useScrollToTop from "./../../../hooks/useScollToTop";

import useCommercesAdmin from "./hooks/useCommercesAdmin";

import CommercesHero from "./components/CommercesHero";
import CommercesStatsGrid from "./components/CommercesStatsGrid";
import CommercesFiltersPanel from "./components/CommercesFiltersPanel";
import CommercesList from "./components/CommercesList";
import CommercesFormDrawer from "./components/CommercesFormDrawer";
import CommercesPreviewDrawer from "./components/CommercesPreviewDrawer";
import CommercesDeleteDrawer from "./components/CommercesDeleteDrawer";

import AdminMediaPickerDrawer from "../_shared/ui/AdminMediaPickerDrawer";
import { COMMERCES_MEDIA_CATEGORY_DEFAULT } from "./data/commercesAdminData";

export default function CommercesAdmin() {
  useScrollToTop();
  const commerces = useCommercesAdmin();

  return (
    <div className="mx-auto w-full max-w-[1600px] px-1 pb-10 sm:px-2 lg:px-0">
      <CommercesHero
        stats={commerces.stats}
        loading={commerces.loading}
        onCreate={commerces.openCreate}
      />

      {commerces.notice ? (
        <div className="mt-5 rounded-[1.5rem] border border-emerald-200 bg-emerald-50 px-5 py-4 text-sm font-bold text-emerald-800 shadow-sm dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
          {commerces.notice}
        </div>
      ) : null}

      {commerces.error ? (
        <div className="mt-5 rounded-[1.5rem] border border-rose-200 bg-rose-50 px-5 py-4 text-sm font-bold text-rose-800 shadow-sm dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300">
          {commerces.error}
        </div>
      ) : null}

      <CommercesStatsGrid
        stats={commerces.stats}
        loading={commerces.loading}
      />

      <CommercesFiltersPanel
        q={commerces.q}
        categorie={commerces.categorie}
        stateFilter={commerces.stateFilter}
        hasLogo={commerces.hasLogo}
        withGps={commerces.withGps}
        limit={commerces.limit}
        onChangeQ={commerces.setQ}
        onChangeCategorie={commerces.changeCategorie}
        onChangeStateFilter={commerces.changeStateFilter}
        onChangeHasLogo={commerces.changeHasLogo}
        onChangeWithGps={commerces.changeWithGps}
        onChangeLimit={commerces.changeLimit}
        onSubmit={commerces.onSubmitSearch}
        onReset={commerces.resetFilters}
        onRefresh={commerces.fetchData}
        loading={commerces.loading}
      />

      <CommercesList
        items={commerces.items}
        loading={commerces.loading}
        total={commerces.total}
        page={commerces.page}
        totalPages={commerces.totalPages}
        actionId={commerces.actionId}
        onPageChange={commerces.setPage}
        onPreview={commerces.openPreview}
        onEdit={commerces.openEdit}
        onToggle={commerces.onToggle}
        onAskDelete={commerces.openDelete}
      />

      <CommercesFormDrawer
        open={commerces.formOpen}
        form={commerces.form}
        fieldErrors={commerces.fieldErrors}
        saving={commerces.saving}
        isEdit={!!commerces.currentId}
        onClose={commerces.closeForm}
        onChange={commerces.updateFormField}
        onSave={commerces.onSave}
        onOpenMediaPicker={commerces.openMediaPicker}
      />

      <CommercesPreviewDrawer
        open={!!commerces.previewItem}
        item={commerces.previewItem}
        onClose={commerces.closePreview}
        onEditFromPreview={commerces.openEditFromPreview}
      />

      <CommercesDeleteDrawer
        open={!!commerces.deleteItem}
        item={commerces.deleteItem}
        deleting={commerces.deleting}
        onClose={commerces.closeDelete}
        onConfirm={commerces.onDelete}
      />

      <AdminMediaPickerDrawer
        open={commerces.mediaPickerOpen}
        onClose={commerces.closeMediaPicker}
        onSelect={commerces.handleSelectMedia}
        title={
          commerces.mediaTargetField === "photo_url"
            ? "Choisir une photo"
            : "Choisir un logo"
        }
        subtitle={
          commerces.mediaTargetField === "photo_url"
            ? "Sélectionnez une photo pour illustrer le commerce."
            : "Sélectionnez une image ou un logo pour représenter le commerce."
        }
        defaultCategory={COMMERCES_MEDIA_CATEGORY_DEFAULT}
      />
    </div>
  );
}